import { apiRequest } from './api'

export function getDashboardStats() {
  return apiRequest('/stats/get', {
    method: 'POST',
  })
}
